import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import BlockUi from 'react-block-ui';
import { Helmet } from 'react-helmet';
import GuestBox from '../../components/GuestBox';
import Link from '../../components/Link';
import ButtonField from '../../components/ButtonField';
import logo from '../../assets/vb-logo.png';
import {
  createLoadingSelector,
  createErrorMessageSelector,
} from '../Main/reducer';
import {
  OTP_VERIFY_REQUEST,
  OTP_RESEND_REQUEST,
  otpVerifyRequest,
  otpResend,
} from './actions';
import TextField from '../../components/LogingTextField';

class OtpVerifyPage extends React.Component {
  state = {
    token: null,
  };

  componentDidMount() {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      this.props.history.push('/forgot-password');
    } else {
      this.setState({ token });
    }
  }

  handleFormSubmit = (values) => {
    const { token } = this.state;
    this.props.otpVerifyRequest({ ...values, token });
  };

  handleResendOtp = () => {
    const { token } = this.state;
    if (token) {
      this.props.otpResend({ token });
    }
  };

  render() {
    const { handleSubmit, loading, error, resendLoading } = this.props;

    return (
      <BlockUi blocking={loading}>
        <Helmet>
          <title>Verify OTP | VoiceboxMD Web</title>
          <meta
            name="description"
            content="Enter the OTP to verify your identity."
          />
        </Helmet>
        <GuestBox>
          <img
            src="./favicon.ico"
            alt="VoiceboxMD Logo"
            style={{ width: '25px', marginBottom: '1rem' }}
          />
          <img
            src={logo}
            alt="VoiceboxMD Logo"
            style={{ width: '150px', marginBottom: '1rem' }}
          />
          <div className="title mb-4">
            <FormattedMessage
              id="OtpVerifyPage.title"
              defaultMessage="Verify OTP"
            />
          </div>
          {error && (
            <div className="text-danger mb-3">
              <FormattedMessage
                id="OtpVerifyPage.error"
                defaultMessage={error || 'An error occurred. Please try again.'}
              />
            </div>
          )}
          <FormattedMessage id="OtpVerifyPage.otp" defaultMessage="OTP Code">
            {(msg) => (
              <Field
                name="otp"
                component={TextField}
                placeholder={msg}
                className="mb-4"
                type="text"
                validate={[this.otpValidator]}
              />
            )}
          </FormattedMessage>
          <ButtonField
            className="mb-3"
            onClick={handleSubmit(this.handleFormSubmit)}
            disabled={loading}
          >
            <FormattedMessage
              id="OtpVerifyPage.submit"
              defaultMessage="Verify OTP"
            />
          </ButtonField>
          <Link
            bold
            onClick={this.handleResendOtp}
            className="forgot"
            disabled={resendLoading}
          >
            <FormattedMessage
              id="OtpVerifyPage.resend"
              defaultMessage="Resend OTP"
            />
          </Link>
        </GuestBox>
      </BlockUi>
    );
  }

  otpValidator = (value) => {
    return value && /^\d{4,6}$/.test(value)
      ? undefined
      : 'Please enter a valid 4-6 digit OTP';
  };
}

OtpVerifyPage = reduxForm({
  form: 'otpVerify',
  validate: (values) => {
    const errors = {};
    if (!values.otp || !/^\d{4,6}$/.test(values.otp)) {
      errors.otp = 'Please enter a valid 4-6 digit OTP';
    }
    return errors;
  },
})(OtpVerifyPage);

OtpVerifyPage = connect(
  createStructuredSelector({
    loading: createLoadingSelector([OTP_VERIFY_REQUEST]),
    resendLoading: createLoadingSelector([OTP_RESEND_REQUEST]),
    error: createErrorMessageSelector([OTP_VERIFY_REQUEST]),
  }),
  { otpVerifyRequest, otpResend }
)(OtpVerifyPage);

export default OtpVerifyPage;
